import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';
import ListingCard from '../components/_ListingCard';
import Pager from '../../common/components/_Pager';

function Events({ entries, search, settings }) { 
    const { items = [] } = entries || {};
	return (
        <div> 
            <div className="row column">
                <div className="large-12 column">
                    {entries.totalCount === 0 && <p>Nothing Found</p>}
                    {entries.totalCount > 0 && 
                        items.map((entry, index) => <ListingCard key={entry.sys.id} entry={entry} index={index} settings={settings} />) }
                </div>
            </div>
            {entries.totalCount > 10 && <Pager entries={entries} search={search} settings={settings} />}
        </div>
	);
}


Events.propTypes = {
    entries: PropTypes.object,
    search: PropTypes.object, 
    filters: PropTypes.object, 
    settings: PropTypes.object
};



const mapStateToProps = state => ({ entries: getEntries(state), search: getSearch(state), filters: getFilters(state), settings: getSettings(state) });

export default connect(mapStateToProps)(Events);